import React, { Component } from 'react'
import { Editor, EditorTools } from '@progress/kendo-react-editor'

const {
  Bold,
  Italic,
  Underline,
  Strikethrough,
  AlignLeft,
  AlignCenter,
  AlignRight,
  AlignJustify,
  ForeColor,
  FontSize,
  FontName,
  Link,
} = EditorTools

export default class ReactEditor extends Component {
  onChange = event => {
    if (!this.props.disabled) {
      this.props.onChange(event.html)
    }
  }

  render() {
    const tools = this.props.tools || []

    return (
      <Editor
        value={this.props.value}
        onChange={this.onChange}
        tools={[
          ...tools,
          Bold,
          Italic,
          Underline,
          Strikethrough,
          AlignLeft,
          AlignCenter,
          AlignRight,
          AlignJustify,
          ForeColor,
          FontSize,
          FontName,
          Link,
        ]}
        contentStyle={{ height: 240 }}
      />
    )
  }
}
